import * as actionTypes from '../actions/actionTypes'

export function languageReducer (state = { currentLanguage: localStorage.getItem('language') || 'en-US' }, action) {
  const newState = { ...state }
  switch (action.type) {
    case actionTypes.GET_LANGUAGE_FULFILLED: {
      newState.constantStrings = action.payload
      return newState
    }
    case actionTypes.UPDATE_SELECTED_LANGUAGE: {
      newState.selectedLanguage = action.payload
      return newState
    }
    case actionTypes.GET_LANGUAGE_REQUESTED: {
      return newState
    }
    case actionTypes.CHANGE_LANGUAGE:
      return { ...newState, currentLanguage: action.payload }
    default:
      return newState
  }
}
